<template>
  <BirthdayMain />
</template>

<script>
import BirthdayMain from '@/components/BirthdayMain.vue'

export default {
  name: 'App',
  components: {
    BirthdayMain
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
